import React, {useState} from 'react'

function WidgetButtons({onBtnChange, defaultDate, ...props}) {
    const [currentButton, setCurrentButton] = useState(defaultDate);

    const onButtonChange = (event, newState) => {
        event.stopPropagation();
        event.preventDefault();
        setCurrentButton(newState);
        onBtnChange(newState);
    }

    return <div className="vc_row wpb_row vc_inner vc_row-fluid dynamic_btn_wrap">
        <div className="wpb_column vc_column_container vc_col-sm-12">
            <div className="vc_column-inner">
                <div className="wpb_wrapper">
                    <div
                        className={"vc_btn3-container  yesterday vc_btn3-inline " + (currentButton === "yesterday" ? "active" : "not-active")}>
                        <a className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-grey"
                            title="" onClick={(e) => onButtonChange(e, "yesterday")}>YESTERDAY</a>
                    </div>
                    <div
                        className={"vc_btn3-container  today vc_btn3-inline " + (currentButton === "today" ? "active" : "not-active")}>
                        <a className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-grey"
                            title="" onClick={(e) => onButtonChange(e, "today")}>TODAY</a>
                    </div>
                    <div
                        className={"vc_btn3-container  tomorrow  vc_btn3-inline " + (currentButton === "tomorrow" ? "active" : "not-active")}>
                        <a className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-modern vc_btn3-color-grey"
                            title="" onClick={(e) => onButtonChange(e, "tomorrow")}>TOMORROW</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}


export default WidgetButtons;
